import React from 'react';
export function ResultsMoreVoices() {
  const voices = [{
    quote: "Michael's course is a perfect blend of strategy, tools, and hands-on AI application for product leaders. The small-cohort setup keeps learning interactive, while his frameworks make it easy to translate concepts into real team impact.",
    author: 'Rajeswari',
    role: 'VP'
  }, {
    quote: 'Michael knows his stuff and provided a clear and practical curriculum. He provided a few really nice frameworks and tools to help implement AI across a product management organization. Definitely recommend this course to others!',
    author: 'Kevin',
    role: 'CPO'
  }, {
    quote: 'Michael helped me make the switch from viewing AI on the sidelines to becoming an active participant. This course changed my understanding of how AI products work and revealed how they are ready to help today.',
    author: 'Sam',
    role: 'Product Director'
  }];
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-261" data-mp="24zl8ls5wizaq">
      <div className="max-w-7xl mx-auto" data-id="element-262" data-mp="20xqa0vfcv00n">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-10" data-id="element-263" data-mp="20vwz33xpltmu">
          What others are saying
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-264" data-mp="1w0hpwpanclwr">
          {voices.map((voice, index) => <div key={index} className="bg-white p-10 rounded-lg shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-265" data-mp="1r1n2tb5ncb6u" data-mpi={index}>
              <blockquote className="text-xl text-brand-gray leading-relaxed italic mb-10 flex-grow" data-id="element-266" data-mp="2johpmepxrmnh">
                "{voice.quote}"
              </blockquote>
              <div className="pt-8 border-t border-gray-100 mt-auto" data-id="element-267" data-mp="29yof7h1j5dkt">
                <div className="font-bold text-brand-navy text-lg" data-id="element-268" data-mp="29wbvayc7ot54">
                  {voice.author}
                </div>
                <div className="text-brand-gray-light text-base mt-2" data-id="element-269" data-mp="32mbtyfg4d9zj">
                  {voice.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}